import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./component/Header";
import Home from "./pages/Home";
import Filme from "./pages/Filme";
import Favorito from "./pages/Favorito";
import Erro from "./pages/Erro";

function RoutesApp() {
    return (
        <BrowserRouter>
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/filme/:id" element={<Filme />} />
                <Route path="/favorito/" element={<Favorito />} />
                <Route path="*" element={<Erro />} />
            </Routes>

        </BrowserRouter>
    )
}

export default RoutesApp;